import { GetCapitSvg, LogoSvg, NextSvg } from "assets/images";
import { StyledLink } from "components";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import "./LeaderBoardScreenHeader.scss";

export const LeaderBoardScreenHeader: FC = (props) => {
  const { t } = useTranslation();

  return (
    <div className="LeaderBoardScreenHeaderContainer">
      <div className="HeaderTitleFirstRow">
        <div className="HeaderLogoContainer">
          <LogoSvg className="LogoImage" />
        </div>
        <div className="HeaderTitleContainerWrapper">
          <div className="HeaderTitleContainer">
            <div className="Title1">{t("title1")}</div>
            <div className="Title2">{t("title2")}</div>
          </div>
        </div>
      </div>
      <div className="HeaderLinksContainerWrapper">
        <div className="HeaderLinksContainer">
          <StyledLink
            text={t("getCapit")}
            Image={
              <GetCapitSvg
                className="StyledLinkImage"
                style={{
                  borderRadius: "10%",
                }}
              />
            }
            url={process.env.REACT_APP_GET_CAPIT_LINK ?? ""}
          />
          <StyledLink
            text={t("enterChallenge")}
            Image={
              <NextSvg  
                className="StyledLinkImage"
              />
            }
            url={process.env.REACT_APP_ENTER_SOUND_CHALLENGE ?? ""}
          />
        </div>
      </div>
    </div>
  );
};
